import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FullPageLoader } from "../../components/ui/FullPageLoader";
import { StatusMessage } from "../../components/ui/StatusMessage";
import { useAuth } from "../../hooks/useAuth";

export function AuthCallbackPage() {
  const navigate = useNavigate();
  const { refreshAuth } = useAuth();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let isMounted = true;

    async function finishAuth() {
      try {
        await refreshAuth();

        if (isMounted) {
          navigate("/", { replace: true });
        }
      } catch (caughtError) {
        if (isMounted) {
          setError(
            caughtError instanceof Error
              ? caughtError.message
              : "Unable to complete authentication.",
          );
        }
      }
    }

    void finishAuth();

    return () => {
      isMounted = false;
    };
  }, [navigate, refreshAuth]);

  if (error) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-paper p-6">
        <div className="w-full max-w-md">
          <StatusMessage message={error} tone="error" />
        </div>
      </div>
    );
  }

  return <FullPageLoader label="Completing sign in" />;
}
